import React from 'react';

const EnergyCertificateGradeC = props => (
  <svg width="166" height="33" viewBox="0 0 166 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 0.312958V32.7941H148.844L165.211 16.4269L148.844 0.312958H0Z" fill="#A3CF2A" />
    <path
      d="M137.699 11.9664C137.28 10.4718 136.481 7.6566 132.171 7.6566C129.668 7.6566 125.982 9.32522 125.982 16.3826C125.982 20.8664 127.755 24.8997 132.171 24.8997C135.054 24.8997 137.073 23.2659 137.699 20.207H142.914C141.87 25.6306 138.324 29.4183 132.067 29.4183C125.427 29.4183 120.663 24.9345 120.663 16.3129C120.663 7.58697 125.704 3.13795 132.135 3.13795C139.61 3.13795 142.636 8.28306 142.914 11.9664H137.699Z"
      fill="white"
    />
  </svg>
);

export default EnergyCertificateGradeC;
